import script from "./changePasswordV2.vue?vue&type=script&setup=true&lang=js"
export * from "./changePasswordV2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__